import { useContext } from 'react';
import { S as SearchContext } from '../contexts/Search/SearchContext-BWoADqXi.js';

const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('SearchContext must be used with SearchProvider');
  }
  return context;
};

export { useSearch as u };
//# sourceMappingURL=useSearch-D9iZPak2.js.map
